import classNames from 'classnames';

const baseProps = {
  h1: { color: 'primary', variant: 'h1', weight: 'bold' },
  h2: { color: 'primary', variant: 'h2', weight: 'bold' },
  h3: { color: 'primary', variant: 'h3', weight: 'bold' },
  h4: { color: 'primary', variant: 'h4', weight: 'bold' },
  h5: { color: 'primary', variant: 'h5', weight: 'bold' },
  h6: { color: 'primary', variant: 'h6', weight: 'bold' },
  paragraph: { color: 'primary', variant: 'body-base', weight: 'regular' }
};

const mapLineClamp = (element, lineClamp, breakpoint = 'default') => classNames({
  // Default h1
  'prose-h1:sui-line-clamp-1': (element === 'h1') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-h1:sui-line-clamp-2': (element === 'h1') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-h1:sui-line-clamp-3': (element === 'h1') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-h1:sui-line-clamp-4': (element === 'h1') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-h1:sui-line-clamp-5': (element === 'h1') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-h1:sui-line-clamp-6': (element === 'h1') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-h1:sui-line-clamp-none': (element === 'h1') && (lineClamp === 'none') && (breakpoint === 'default'),
  // Default h2
  'prose-h2:sui-line-clamp-1': (element === 'h2') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-h2:sui-line-clamp-2': (element === 'h2') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-h2:sui-line-clamp-3': (element === 'h2') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-h2:sui-line-clamp-4': (element === 'h2') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-h2:sui-line-clamp-5': (element === 'h2') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-h2:sui-line-clamp-6': (element === 'h2') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-h2:sui-line-clamp-none': (element === 'h2') && (lineClamp === 'none') && (breakpoint === 'default'),
  // Default h3
  'prose-h3:sui-line-clamp-1': (element === 'h3') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-h3:sui-line-clamp-2': (element === 'h3') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-h3:sui-line-clamp-3': (element === 'h3') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-h3:sui-line-clamp-4': (element === 'h3') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-h3:sui-line-clamp-5': (element === 'h3') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-h3:sui-line-clamp-6': (element === 'h3') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-h3:sui-line-clamp-none': (element === 'h3') && (lineClamp === 'none') && (breakpoint === 'default'),
  // Default h4
  'prose-h4:sui-line-clamp-1': (element === 'h4') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-h4:sui-line-clamp-2': (element === 'h4') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-h4:sui-line-clamp-3': (element === 'h4') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-h4:sui-line-clamp-4': (element === 'h4') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-h4:sui-line-clamp-5': (element === 'h4') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-h4:sui-line-clamp-6': (element === 'h4') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-h4:sui-line-clamp-none': (element === 'h4') && (lineClamp === 'none') && (breakpoint === 'default'),
  // Default h5
  'prose-h5:sui-line-clamp-1': (element === 'h5') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-h5:sui-line-clamp-2': (element === 'h5') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-h5:sui-line-clamp-3': (element === 'h5') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-h5:sui-line-clamp-4': (element === 'h5') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-h5:sui-line-clamp-5': (element === 'h5') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-h5:sui-line-clamp-6': (element === 'h5') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-h5:sui-line-clamp-none': (element === 'h5') && (lineClamp === 'none') && (breakpoint === 'default'),
  // Default h6
  'prose-h6:sui-line-clamp-1': (element === 'h6') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-h6:sui-line-clamp-2': (element === 'h6') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-h6:sui-line-clamp-3': (element === 'h6') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-h6:sui-line-clamp-4': (element === 'h6') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-h6:sui-line-clamp-5': (element === 'h6') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-h6:sui-line-clamp-6': (element === 'h6') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-h6:sui-line-clamp-none': (element === 'h6') && (lineClamp === 'none') && (breakpoint === 'default'),
  // Default body
  'prose-p:sui-line-clamp-1': (element === 'paragraph') && (lineClamp === 1) && (breakpoint === 'default'),
  'prose-p:sui-line-clamp-2': (element === 'paragraph') && (lineClamp === 2) && (breakpoint === 'default'),
  'prose-p:sui-line-clamp-3': (element === 'paragraph') && (lineClamp === 3) && (breakpoint === 'default'),
  'prose-p:sui-line-clamp-4': (element === 'paragraph') && (lineClamp === 4) && (breakpoint === 'default'),
  'prose-p:sui-line-clamp-5': (element === 'paragraph') && (lineClamp === 5) && (breakpoint === 'default'),
  'prose-p:sui-line-clamp-6': (element === 'paragraph') && (lineClamp === 6) && (breakpoint === 'default'),
  'prose-p:sui-line-clamp-none': (element === 'paragraph') && (lineClamp === 'none') && (breakpoint === 'default'),
  // small h1
  'prose-h1:sm:sui-line-clamp-1': (element === 'h1') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-h1:sm:sui-line-clamp-2': (element === 'h1') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-h1:sm:sui-line-clamp-3': (element === 'h1') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-h1:sm:sui-line-clamp-4': (element === 'h1') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-h1:sm:sui-line-clamp-5': (element === 'h1') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-h1:sm:sui-line-clamp-6': (element === 'h1') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-h1:sm:sui-line-clamp-none': (element === 'h1') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // small h2
  'prose-h2:sm:sui-line-clamp-1': (element === 'h2') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-h2:sm:sui-line-clamp-2': (element === 'h2') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-h2:sm:sui-line-clamp-3': (element === 'h2') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-h2:sm:sui-line-clamp-4': (element === 'h2') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-h2:sm:sui-line-clamp-5': (element === 'h2') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-h2:sm:sui-line-clamp-6': (element === 'h2') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-h2:sm:sui-line-clamp-none': (element === 'h2') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // small h3
  'prose-h3:sm:sui-line-clamp-1': (element === 'h3') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-h3:sm:sui-line-clamp-2': (element === 'h3') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-h3:sm:sui-line-clamp-3': (element === 'h3') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-h3:sm:sui-line-clamp-4': (element === 'h3') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-h3:sm:sui-line-clamp-5': (element === 'h3') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-h3:sm:sui-line-clamp-6': (element === 'h3') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-h3:sm:sui-line-clamp-none': (element === 'h3') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // small h4
  'prose-h4:sm:sui-line-clamp-1': (element === 'h4') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-h4:sm:sui-line-clamp-2': (element === 'h4') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-h4:sm:sui-line-clamp-3': (element === 'h4') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-h4:sm:sui-line-clamp-4': (element === 'h4') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-h4:sm:sui-line-clamp-5': (element === 'h4') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-h4:sm:sui-line-clamp-6': (element === 'h4') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-h4:sm:sui-line-clamp-none': (element === 'h4') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // small h5
  'prose-h5:sm:sui-line-clamp-1': (element === 'h5') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-h5:sm:sui-line-clamp-2': (element === 'h5') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-h5:sm:sui-line-clamp-3': (element === 'h5') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-h5:sm:sui-line-clamp-4': (element === 'h5') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-h5:sm:sui-line-clamp-5': (element === 'h5') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-h5:sm:sui-line-clamp-6': (element === 'h5') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-h5:sm:sui-line-clamp-none': (element === 'h5') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // small h6
  'prose-h6:sm:sui-line-clamp-1': (element === 'h6') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-h6:sm:sui-line-clamp-2': (element === 'h6') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-h6:sm:sui-line-clamp-3': (element === 'h6') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-h6:sm:sui-line-clamp-4': (element === 'h6') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-h6:sm:sui-line-clamp-5': (element === 'h6') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-h6:sm:sui-line-clamp-6': (element === 'h6') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-h6:sm:sui-line-clamp-none': (element === 'h6') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // small body
  'prose-p:sm:sui-line-clamp-1': (element === 'paragraph') && (lineClamp === 1) && (breakpoint === 'sm'),
  'prose-p:sm:sui-line-clamp-2': (element === 'paragraph') && (lineClamp === 2) && (breakpoint === 'sm'),
  'prose-p:sm:sui-line-clamp-3': (element === 'paragraph') && (lineClamp === 3) && (breakpoint === 'sm'),
  'prose-p:sm:sui-line-clamp-4': (element === 'paragraph') && (lineClamp === 4) && (breakpoint === 'sm'),
  'prose-p:sm:sui-line-clamp-5': (element === 'paragraph') && (lineClamp === 5) && (breakpoint === 'sm'),
  'prose-p:sm:sui-line-clamp-6': (element === 'paragraph') && (lineClamp === 6) && (breakpoint === 'sm'),
  'prose-p:sm:sui-line-clamp-none': (element === 'paragraph') && (lineClamp === 'none') && (breakpoint === 'sm'),
  // medium h1
  'prose-h1:md:sui-line-clamp-1': (element === 'h1') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-h1:md:sui-line-clamp-2': (element === 'h1') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-h1:md:sui-line-clamp-3': (element === 'h1') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-h1:md:sui-line-clamp-4': (element === 'h1') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-h1:md:sui-line-clamp-5': (element === 'h1') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-h1:md:sui-line-clamp-6': (element === 'h1') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-h1:md:sui-line-clamp-none': (element === 'h1') && (lineClamp === 'none') && (breakpoint === 'md'),
  // medium h2
  'prose-h2:md:sui-line-clamp-1': (element === 'h2') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-h2:md:sui-line-clamp-2': (element === 'h2') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-h2:md:sui-line-clamp-3': (element === 'h2') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-h2:md:sui-line-clamp-4': (element === 'h2') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-h2:md:sui-line-clamp-5': (element === 'h2') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-h2:md:sui-line-clamp-6': (element === 'h2') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-h2:md:sui-line-clamp-none': (element === 'h2') && (lineClamp === 'none') && (breakpoint === 'md'),
  // medium h3
  'prose-h3:md:sui-line-clamp-1': (element === 'h3') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-h3:md:sui-line-clamp-2': (element === 'h3') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-h3:md:sui-line-clamp-3': (element === 'h3') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-h3:md:sui-line-clamp-4': (element === 'h3') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-h3:md:sui-line-clamp-5': (element === 'h3') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-h3:md:sui-line-clamp-6': (element === 'h3') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-h3:md:sui-line-clamp-none': (element === 'h3') && (lineClamp === 'none') && (breakpoint === 'md'),
  // medium h4
  'prose-h4:md:sui-line-clamp-1': (element === 'h4') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-h4:md:sui-line-clamp-2': (element === 'h4') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-h4:md:sui-line-clamp-3': (element === 'h4') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-h4:md:sui-line-clamp-4': (element === 'h4') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-h4:md:sui-line-clamp-5': (element === 'h4') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-h4:md:sui-line-clamp-6': (element === 'h4') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-h4:md:sui-line-clamp-none': (element === 'h4') && (lineClamp === 'none') && (breakpoint === 'md'),
  // medium h5
  'prose-h5:md:sui-line-clamp-1': (element === 'h5') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-h5:md:sui-line-clamp-2': (element === 'h5') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-h5:md:sui-line-clamp-3': (element === 'h5') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-h5:md:sui-line-clamp-4': (element === 'h5') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-h5:md:sui-line-clamp-5': (element === 'h5') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-h5:md:sui-line-clamp-6': (element === 'h5') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-h5:md:sui-line-clamp-none': (element === 'h5') && (lineClamp === 'none') && (breakpoint === 'md'),
  // medium h6
  'prose-h6:md:sui-line-clamp-1': (element === 'h6') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-h6:md:sui-line-clamp-2': (element === 'h6') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-h6:md:sui-line-clamp-3': (element === 'h6') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-h6:md:sui-line-clamp-4': (element === 'h6') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-h6:md:sui-line-clamp-5': (element === 'h6') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-h6:md:sui-line-clamp-6': (element === 'h6') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-h6:md:sui-line-clamp-none': (element === 'h6') && (lineClamp === 'none') && (breakpoint === 'md'),
  // medium body
  'prose-p:md:sui-line-clamp-1': (element === 'paragraph') && (lineClamp === 1) && (breakpoint === 'md'),
  'prose-p:md:sui-line-clamp-2': (element === 'paragraph') && (lineClamp === 2) && (breakpoint === 'md'),
  'prose-p:md:sui-line-clamp-3': (element === 'paragraph') && (lineClamp === 3) && (breakpoint === 'md'),
  'prose-p:md:sui-line-clamp-4': (element === 'paragraph') && (lineClamp === 4) && (breakpoint === 'md'),
  'prose-p:md:sui-line-clamp-5': (element === 'paragraph') && (lineClamp === 5) && (breakpoint === 'md'),
  'prose-p:md:sui-line-clamp-6': (element === 'paragraph') && (lineClamp === 6) && (breakpoint === 'md'),
  'prose-p:md:sui-line-clamp-none': (element === 'paragraph') && (lineClamp === 'none') && (breakpoint === 'md'),
  // large h1
  'prose-h1:lg:sui-line-clamp-1': (element === 'h1') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-h1:lg:sui-line-clamp-2': (element === 'h1') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-h1:lg:sui-line-clamp-3': (element === 'h1') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-h1:lg:sui-line-clamp-4': (element === 'h1') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-h1:lg:sui-line-clamp-5': (element === 'h1') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-h1:lg:sui-line-clamp-6': (element === 'h1') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-h1:lg:sui-line-clamp-none': (element === 'h1') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // large h2
  'prose-h2:lg:sui-line-clamp-1': (element === 'h2') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-h2:lg:sui-line-clamp-2': (element === 'h2') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-h2:lg:sui-line-clamp-3': (element === 'h2') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-h2:lg:sui-line-clamp-4': (element === 'h2') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-h2:lg:sui-line-clamp-5': (element === 'h2') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-h2:lg:sui-line-clamp-6': (element === 'h2') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-h2:lg:sui-line-clamp-none': (element === 'h2') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // large h3
  'prose-h3:lg:sui-line-clamp-1': (element === 'h3') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-h3:lg:sui-line-clamp-2': (element === 'h3') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-h3:lg:sui-line-clamp-3': (element === 'h3') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-h3:lg:sui-line-clamp-4': (element === 'h3') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-h3:lg:sui-line-clamp-5': (element === 'h3') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-h3:lg:sui-line-clamp-6': (element === 'h3') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-h3:lg:sui-line-clamp-none': (element === 'h3') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // large h4
  'prose-h4:lg:sui-line-clamp-1': (element === 'h4') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-h4:lg:sui-line-clamp-2': (element === 'h4') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-h4:lg:sui-line-clamp-3': (element === 'h4') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-h4:lg:sui-line-clamp-4': (element === 'h4') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-h4:lg:sui-line-clamp-5': (element === 'h4') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-h4:lg:sui-line-clamp-6': (element === 'h4') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-h4:lg:sui-line-clamp-none': (element === 'h4') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // large h5
  'prose-h5:lg:sui-line-clamp-1': (element === 'h5') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-h5:lg:sui-line-clamp-2': (element === 'h5') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-h5:lg:sui-line-clamp-3': (element === 'h5') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-h5:lg:sui-line-clamp-4': (element === 'h5') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-h5:lg:sui-line-clamp-5': (element === 'h5') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-h5:lg:sui-line-clamp-6': (element === 'h5') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-h5:lg:sui-line-clamp-none': (element === 'h5') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // large h6
  'prose-h6:lg:sui-line-clamp-1': (element === 'h6') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-h6:lg:sui-line-clamp-2': (element === 'h6') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-h6:lg:sui-line-clamp-3': (element === 'h6') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-h6:lg:sui-line-clamp-4': (element === 'h6') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-h6:lg:sui-line-clamp-5': (element === 'h6') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-h6:lg:sui-line-clamp-6': (element === 'h6') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-h6:lg:sui-line-clamp-none': (element === 'h6') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // large body
  'prose-p:lg:sui-line-clamp-1': (element === 'paragraph') && (lineClamp === 1) && (breakpoint === 'lg'),
  'prose-p:lg:sui-line-clamp-2': (element === 'paragraph') && (lineClamp === 2) && (breakpoint === 'lg'),
  'prose-p:lg:sui-line-clamp-3': (element === 'paragraph') && (lineClamp === 3) && (breakpoint === 'lg'),
  'prose-p:lg:sui-line-clamp-4': (element === 'paragraph') && (lineClamp === 4) && (breakpoint === 'lg'),
  'prose-p:lg:sui-line-clamp-5': (element === 'paragraph') && (lineClamp === 5) && (breakpoint === 'lg'),
  'prose-p:lg:sui-line-clamp-6': (element === 'paragraph') && (lineClamp === 6) && (breakpoint === 'lg'),
  'prose-p:lg:sui-line-clamp-none': (element === 'paragraph') && (lineClamp === 'none') && (breakpoint === 'lg'),
  // xl h1
  'prose-h1:xl:sui-line-clamp-1': (element === 'h1') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-h1:xl:sui-line-clamp-2': (element === 'h1') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-h1:xl:sui-line-clamp-3': (element === 'h1') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-h1:xl:sui-line-clamp-4': (element === 'h1') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-h1:xl:sui-line-clamp-5': (element === 'h1') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-h1:xl:sui-line-clamp-6': (element === 'h1') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-h1:xl:sui-line-clamp-none': (element === 'h1') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl h2
  'prose-h2:xl:sui-line-clamp-1': (element === 'h2') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-h2:xl:sui-line-clamp-2': (element === 'h2') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-h2:xl:sui-line-clamp-3': (element === 'h2') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-h2:xl:sui-line-clamp-4': (element === 'h2') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-h2:xl:sui-line-clamp-5': (element === 'h2') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-h2:xl:sui-line-clamp-6': (element === 'h2') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-h2:xl:sui-line-clamp-none': (element === 'h2') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl h3
  'prose-h3:xl:sui-line-clamp-1': (element === 'h3') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-h3:xl:sui-line-clamp-2': (element === 'h3') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-h3:xl:sui-line-clamp-3': (element === 'h3') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-h3:xl:sui-line-clamp-4': (element === 'h3') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-h3:xl:sui-line-clamp-5': (element === 'h3') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-h3:xl:sui-line-clamp-6': (element === 'h3') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-h3:xl:sui-line-clamp-none': (element === 'h3') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl h4
  'prose-h4:xl:sui-line-clamp-1': (element === 'h4') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-h4:xl:sui-line-clamp-2': (element === 'h4') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-h4:xl:sui-line-clamp-3': (element === 'h4') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-h4:xl:sui-line-clamp-4': (element === 'h4') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-h4:xl:sui-line-clamp-5': (element === 'h4') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-h4:xl:sui-line-clamp-6': (element === 'h4') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-h4:xl:sui-line-clamp-none': (element === 'h4') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl h5
  'prose-h5:xl:sui-line-clamp-1': (element === 'h5') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-h5:xl:sui-line-clamp-2': (element === 'h5') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-h5:xl:sui-line-clamp-3': (element === 'h5') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-h5:xl:sui-line-clamp-4': (element === 'h5') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-h5:xl:sui-line-clamp-5': (element === 'h5') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-h5:xl:sui-line-clamp-6': (element === 'h5') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-h5:xl:sui-line-clamp-none': (element === 'h5') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl h6
  'prose-h6:xl:sui-line-clamp-1': (element === 'h6') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-h6:xl:sui-line-clamp-2': (element === 'h6') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-h6:xl:sui-line-clamp-3': (element === 'h6') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-h6:xl:sui-line-clamp-4': (element === 'h6') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-h6:xl:sui-line-clamp-5': (element === 'h6') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-h6:xl:sui-line-clamp-6': (element === 'h6') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-h6:xl:sui-line-clamp-none': (element === 'h6') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl body
  'prose-p:xl:sui-line-clamp-1': (element === 'paragraph') && (lineClamp === 1) && (breakpoint === 'xl'),
  'prose-p:xl:sui-line-clamp-2': (element === 'paragraph') && (lineClamp === 2) && (breakpoint === 'xl'),
  'prose-p:xl:sui-line-clamp-3': (element === 'paragraph') && (lineClamp === 3) && (breakpoint === 'xl'),
  'prose-p:xl:sui-line-clamp-4': (element === 'paragraph') && (lineClamp === 4) && (breakpoint === 'xl'),
  'prose-p:xl:sui-line-clamp-5': (element === 'paragraph') && (lineClamp === 5) && (breakpoint === 'xl'),
  'prose-p:xl:sui-line-clamp-6': (element === 'paragraph') && (lineClamp === 6) && (breakpoint === 'xl'),
  'prose-p:xl:sui-line-clamp-none': (element === 'paragraph') && (lineClamp === 'none') && (breakpoint === 'xl'),
  // xl h1
  'prose-h1:2xl:sui-line-clamp-1': (element === 'h1') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-h1:2xl:sui-line-clamp-2': (element === 'h1') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-h1:2xl:sui-line-clamp-3': (element === 'h1') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-h1:2xl:sui-line-clamp-4': (element === 'h1') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-h1:2xl:sui-line-clamp-5': (element === 'h1') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-h1:2xl:sui-line-clamp-6': (element === 'h1') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-h1:2xl:sui-line-clamp-none': (element === 'h1') && (lineClamp === 'none') && (breakpoint === '2xl'),
  // xl h2
  'prose-h2:2xl:sui-line-clamp-1': (element === 'h2') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-h2:2xl:sui-line-clamp-2': (element === 'h2') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-h2:2xl:sui-line-clamp-3': (element === 'h2') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-h2:2xl:sui-line-clamp-4': (element === 'h2') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-h2:2xl:sui-line-clamp-5': (element === 'h2') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-h2:2xl:sui-line-clamp-6': (element === 'h2') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-h2:2xl:sui-line-clamp-none': (element === 'h2') && (lineClamp === 'none') && (breakpoint === '2xl'),
  // xl h3
  'prose-h3:2xl:sui-line-clamp-1': (element === 'h3') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-h3:2xl:sui-line-clamp-2': (element === 'h3') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-h3:2xl:sui-line-clamp-3': (element === 'h3') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-h3:2xl:sui-line-clamp-4': (element === 'h3') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-h3:2xl:sui-line-clamp-5': (element === 'h3') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-h3:2xl:sui-line-clamp-6': (element === 'h3') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-h3:2xl:sui-line-clamp-none': (element === 'h3') && (lineClamp === 'none') && (breakpoint === '2xl'),
  // xl h4
  'prose-h4:2xl:sui-line-clamp-1': (element === 'h4') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-h4:2xl:sui-line-clamp-2': (element === 'h4') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-h4:2xl:sui-line-clamp-3': (element === 'h4') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-h4:2xl:sui-line-clamp-4': (element === 'h4') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-h4:2xl:sui-line-clamp-5': (element === 'h4') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-h4:2xl:sui-line-clamp-6': (element === 'h4') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-h4:2xl:sui-line-clamp-none': (element === 'h4') && (lineClamp === 'none') && (breakpoint === '2xl'),
  // xl h5
  'prose-h5:2xl:sui-line-clamp-1': (element === 'h5') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-h5:2xl:sui-line-clamp-2': (element === 'h5') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-h5:2xl:sui-line-clamp-3': (element === 'h5') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-h5:2xl:sui-line-clamp-4': (element === 'h5') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-h5:2xl:sui-line-clamp-5': (element === 'h5') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-h5:2xl:sui-line-clamp-6': (element === 'h5') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-h5:2xl:sui-line-clamp-none': (element === 'h5') && (lineClamp === 'none') && (breakpoint === '2xl'),
  // xl h6
  'prose-h6:2xl:sui-line-clamp-1': (element === 'h6') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-h6:2xl:sui-line-clamp-2': (element === 'h6') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-h6:2xl:sui-line-clamp-3': (element === 'h6') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-h6:2xl:sui-line-clamp-4': (element === 'h6') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-h6:2xl:sui-line-clamp-5': (element === 'h6') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-h6:2xl:sui-line-clamp-6': (element === 'h6') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-h6:2xl:sui-line-clamp-none': (element === 'h6') && (lineClamp === 'none') && (breakpoint === '2xl'),
  // xl body
  'prose-p:2xl:sui-line-clamp-1': (element === 'paragraph') && (lineClamp === 1) && (breakpoint === '2xl'),
  'prose-p:2xl:sui-line-clamp-2': (element === 'paragraph') && (lineClamp === 2) && (breakpoint === '2xl'),
  'prose-p:2xl:sui-line-clamp-3': (element === 'paragraph') && (lineClamp === 3) && (breakpoint === '2xl'),
  'prose-p:2xl:sui-line-clamp-4': (element === 'paragraph') && (lineClamp === 4) && (breakpoint === '2xl'),
  'prose-p:2xl:sui-line-clamp-5': (element === 'paragraph') && (lineClamp === 5) && (breakpoint === '2xl'),
  'prose-p:2xl:sui-line-clamp-6': (element === 'paragraph') && (lineClamp === 6) && (breakpoint === '2xl'),
  'prose-p:2xl:sui-line-clamp-none': (element === 'paragraph') && (lineClamp === 'none') && (breakpoint === '2xl')
});

const getAlignmentClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { align } = entries[0][1];

  return classNames({
    // h1 Heading
    'prose-h1:sui-text-left': (align === 'left') && (element === 'h1'),
    'prose-h1:sui-text-center': (align === 'center') && (element === 'h1'),
    'prose-h1:sui-text-right': (align === 'right') && (element === 'h1'),
    'prose-h1:sui-text-justify': (align === 'justify') && (element === 'h1'),
    // h2 Heading
    'prose-h2:sui-text-left': (align === 'left') && (element === 'h2'),
    'prose-h2:sui-text-center': (align === 'center') && (element === 'h2'),
    'prose-h2:sui-text-right': (align === 'right') && (element === 'h2'),
    'prose-h2:sui-text-justify': (align === 'justify') && (element === 'h2'),
    // h3 Heading
    'prose-h3:sui-text-left': (align === 'left') && (element === 'h3'),
    'prose-h3:sui-text-center': (align === 'center') && (element === 'h3'),
    'prose-h3:sui-text-right': (align === 'right') && (element === 'h3'),
    'prose-h3:sui-text-justify': (align === 'justify') && (element === 'h3'),
    // h4 Heading
    'prose-h4:sui-text-left': (align === 'left') && (element === 'h4'),
    'prose-h4:sui-text-center': (align === 'center') && (element === 'h4'),
    'prose-h4:sui-text-right': (align === 'right') && (element === 'h4'),
    'prose-h4:sui-text-justify': (align === 'justify') && (element === 'h4'),
    // h5 Heading
    'prose-h5:sui-text-left': (align === 'left') && (element === 'h5'),
    'prose-h5:sui-text-center': (align === 'center') && (element === 'h5'),
    'prose-h5:sui-text-right': (align === 'right') && (element === 'h5'),
    'prose-h5:sui-text-justify': (align === 'justify') && (element === 'h5'),
    // h6 heading
    'prose-h6:sui-text-left': (align === 'left') && (element === 'h6'),
    'prose-h6:sui-text-center': (align === 'center') && (element === 'h6'),
    'prose-h6:sui-text-right': (align === 'right') && (element === 'h6'),
    'prose-h6:sui-text-justify': (align === 'justify') && (element === 'h6'),
    // Body
    'prose-p:sui-text-left': (align === 'left') && (element === 'paragraph'),
    'prose-p:sui-text-center': (align === 'center') && (element === 'paragraph'),
    'prose-p:sui-text-right': (align === 'right') && (element === 'paragraph'),
    'prose-p:sui-text-justify': (align === 'justify') && (element === 'paragraph')
  });
};

const getColorClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { color } = entries[0][1];

  return classNames({
    // h1 heading
    'prose-h1:sui-text-primary': (color === 'primary') && (element === 'h1'),
    'prose-h1:sui-text-subtle': (color === 'subtle') && (element === 'h1'),
    'prose-h1:sui-text-info': (color === 'info') && (element === 'h1'),
    'prose-h1:sui-text-success': (color === 'success') && (element === 'h1'),
    'prose-h1:sui-text-warning': (color === 'warning') && (element === 'h1'),
    'prose-h1:sui-text-danger': (color === 'danger') && (element === 'h1'),
    'prose-h1:sui-text-brand': (color === 'brand') && (element === 'h1'),
    'prose-h1:sui-text-inverse': (color === 'inverse') && (element === 'h1'),
    'prose-h1:sui-text-inactive': (color === 'inactive') && (element === 'h1'),
    // h2 heading
    'prose-h2:sui-text-primary': (color === 'primary') && (element === 'h2'),
    'prose-h2:sui-text-subtle': (color === 'subtle') && (element === 'h2'),
    'prose-h2:sui-text-info': (color === 'info') && (element === 'h2'),
    'prose-h2:sui-text-success': (color === 'success') && (element === 'h2'),
    'prose-h2:sui-text-warning': (color === 'warning') && (element === 'h2'),
    'prose-h2:sui-text-danger': (color === 'danger') && (element === 'h2'),
    'prose-h2:sui-text-brand': (color === 'brand') && (element === 'h2'),
    'prose-h2:sui-text-inverse': (color === 'inverse') && (element === 'h2'),
    'prose-h2:sui-text-inactive': (color === 'inactive') && (element === 'h2'),
    // h3 heading
    'prose-h3:sui-text-primary': (color === 'primary') && (element === 'h3'),
    'prose-h3:sui-text-subtle': (color === 'subtle') && (element === 'h3'),
    'prose-h3:sui-text-info': (color === 'info') && (element === 'h3'),
    'prose-h3:sui-text-success': (color === 'success') && (element === 'h3'),
    'prose-h3:sui-text-warning': (color === 'warning') && (element === 'h3'),
    'prose-h3:sui-text-danger': (color === 'danger') && (element === 'h3'),
    'prose-h3:sui-text-brand': (color === 'brand') && (element === 'h3'),
    'prose-h3:sui-text-inverse': (color === 'inverse') && (element === 'h3'),
    'prose-h3:sui-text-inactive': (color === 'inactive') && (element === 'h3'),
    // h4 heading
    'prose-h4:sui-text-primary': (color === 'primary') && (element === 'h4'),
    'prose-h4:sui-text-subtle': (color === 'subtle') && (element === 'h4'),
    'prose-h4:sui-text-info': (color === 'info') && (element === 'h4'),
    'prose-h4:sui-text-success': (color === 'success') && (element === 'h4'),
    'prose-h4:sui-text-warning': (color === 'warning') && (element === 'h4'),
    'prose-h4:sui-text-danger': (color === 'danger') && (element === 'h4'),
    'prose-h4:sui-text-brand': (color === 'brand') && (element === 'h4'),
    'prose-h4:sui-text-inverse': (color === 'inverse') && (element === 'h4'),
    'prose-h4:sui-text-inactive': (color === 'inactive') && (element === 'h4'),
    // h5 heading
    'prose-h5:sui-text-primary': (color === 'primary') && (element === 'h5'),
    'prose-h5:sui-text-subtle': (color === 'subtle') && (element === 'h5'),
    'prose-h5:sui-text-info': (color === 'info') && (element === 'h5'),
    'prose-h5:sui-text-success': (color === 'success') && (element === 'h5'),
    'prose-h5:sui-text-warning': (color === 'warning') && (element === 'h5'),
    'prose-h5:sui-text-danger': (color === 'danger') && (element === 'h5'),
    'prose-h5:sui-text-brand': (color === 'brand') && (element === 'h5'),
    'prose-h5:sui-text-inverse': (color === 'inverse') && (element === 'h5'),
    'prose-h5:sui-text-inactive': (color === 'inactive') && (element === 'h5'),
    // h6 heading
    'prose-h6:sui-text-primary': (color === 'primary') && (element === 'h6'),
    'prose-h6:sui-text-subtle': (color === 'subtle') && (element === 'h6'),
    'prose-h6:sui-text-info': (color === 'info') && (element === 'h6'),
    'prose-h6:sui-text-success': (color === 'success') && (element === 'h6'),
    'prose-h6:sui-text-warning': (color === 'warning') && (element === 'h6'),
    'prose-h6:sui-text-danger': (color === 'danger') && (element === 'h6'),
    'prose-h6:sui-text-brand': (color === 'brand') && (element === 'h6'),
    'prose-h6:sui-text-inverse': (color === 'inverse') && (element === 'h6'),
    'prose-h6:sui-text-inactive': (color === 'inactive') && (element === 'h6'),
    // Body
    'prose-p:sui-text-primary': (color === 'primary') && (element === 'paragraph'),
    'prose-p:sui-text-subtle': (color === 'subtle') && (element === 'paragraph'),
    'prose-p:sui-text-info': (color === 'info') && (element === 'paragraph'),
    'prose-p:sui-text-success': (color === 'success') && (element === 'paragraph'),
    'prose-p:sui-text-warning': (color === 'warning') && (element === 'paragraph'),
    'prose-p:sui-text-danger': (color === 'danger') && (element === 'paragraph'),
    'prose-p:sui-text-brand': (color === 'brand') && (element === 'paragraph'),
    'prose-p:sui-text-inverse': (color === 'inverse') && (element === 'paragraph'),
    'prose-p:sui-text-inactive': (color === 'inactive') && (element === 'paragraph')
  });
};

const getDecorationClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { decoration } = entries[0][1];

  return classNames({
    // headings
    'prose-h1:sui-underline': (decoration === 'underline') && (element === 'h1'),
    'prose-h2:sui-underline': (decoration === 'underline') && (element === 'h2'),
    'prose-h3:sui-underline': (decoration === 'underline') && (element === 'h3'),
    'prose-h4:sui-underline': (decoration === 'underline') && (element === 'h4'),
    'prose-h5:sui-underline': (decoration === 'underline') && (element === 'h5'),
    'prose-h6:sui-underline': (decoration === 'underline') && (element === 'h6'),
    // body
    'prose-p:sui-underline': (decoration === 'underline') && (element === 'paragraph'),
    'prose-p:sui-line-through': (decoration === 'line-through') && (element === 'paragraph')
  });
};

const getHeightClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { height, variant } = entries[0][1];

  const isLeadingNoneVariant = variant === 'h1' || variant === 'h2' || variant === 'h3' || variant === 'h4';
  const isLeadingSnugVariant = variant === 'h5' || variant === 'h6';

  return classNames({
    // Headings
    'prose-h1:sui-leading-none': (height === 'none') && (element === 'h1') && isLeadingNoneVariant,
    'prose-h2:sui-leading-none': (height === 'none') && (element === 'h2') && isLeadingNoneVariant,
    'prose-h3:sui-leading-none': (height === 'none') && (element === 'h3') && isLeadingNoneVariant,
    'prose-h4:sui-leading-none': (height === 'none') && (element === 'h4') && isLeadingNoneVariant,
    'prose-h5:sui-leading-none': (height === 'none') && (element === 'h5') && isLeadingNoneVariant,
    'prose-h6:sui-leading-none': (height === 'none') && (element === 'h6') && isLeadingNoneVariant,
    'prose-h1:sui-leading-snug': (height === 'snug') && (element === 'h1') && isLeadingSnugVariant,
    'prose-h2:sui-leading-snug': (height === 'snug') && (element === 'h2') && isLeadingSnugVariant,
    'prose-h3:sui-leading-snug': (height === 'snug') && (element === 'h3') && isLeadingSnugVariant,
    'prose-h4:sui-leading-snug': (height === 'snug') && (element === 'h4') && isLeadingSnugVariant,
    'prose-h5:sui-leading-snug': (height === 'snug') && (element === 'h5') && isLeadingSnugVariant,
    'prose-h6:sui-leading-snug': (height === 'snug') && (element === 'h6') && isLeadingSnugVariant,
    // Body
    'prose-p:sui-leading-tight': (element === 'paragraph') && (height === 'tight'),
    'prose-p:sui-leading-normal': (element === 'paragraph') && (height === 'normal'),
    'prose-p:sui-leading-loose': (element === 'paragraph') && (height === 'loose') && (variant === 'body-base')
  });
};

const getLineClampClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { lineClamp } = entries[0][1];

  const isObject = typeof lineClamp === 'object';

  if (isObject) {
    return Object.entries(lineClamp).map((entry) => {
      const breakpoint = entry[0];
      const line = entry[1];

      return mapLineClamp(element, line, breakpoint);
    }).filter((ele) => ele !== '' && ele !== undefined).join(' ')
      .trim();
  }

  return mapLineClamp(element, lineClamp, 'default');
};

const getTruncateClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { truncate } = entries[0][1];

  return classNames({
    // headings
    'prose-h1:sui-truncate': (element === 'h1') && truncate,
    'prose-h2:sui-truncate': (element === 'h2') && truncate,
    'prose-h3:sui-truncate': (element === 'h3') && truncate,
    'prose-h4:sui-truncate': (element === 'h4') && truncate,
    'prose-h5:sui-truncate': (element === 'h5') && truncate,
    'prose-h6:sui-truncate': (element === 'h6') && truncate,
    // body
    'prose-p:sui-truncate': (element === 'paragraph') && truncate
  });
};

const getUppercaseClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { uppercase, weight } = entries[0][1];

  return classNames({
    // headings
    'prose-h1:sui-uppercase': (element === 'h1') && (weight === 'display') && uppercase,
    'prose-h2:sui-uppercase': (element === 'h2') && (weight === 'display') && uppercase,
    'prose-h3:sui-uppercase': (element === 'h3') && (weight === 'display') && uppercase,
    'prose-h4:sui-uppercase': (element === 'h4') && (weight === 'display') && uppercase,
    'prose-h5:sui-uppercase': (element === 'h5') && (weight === 'display') && uppercase,
    'prose-h6:sui-uppercase': (element === 'h6') && (weight === 'display') && uppercase
  });
};

const getVariantClasses = (prop) => {
  const entries = Object.entries(prop);
  const element = entries[0][0];
  const { variant, weight } = entries[0][1];

  return classNames({
    // H1 element bold styling
    'prose-h1:sui-h1-bold': (element === 'h1') && (variant === 'h1') && (weight === 'bold'),
    'prose-h2:sui-h1-bold': (element === 'h2') && (variant === 'h1') && (weight === 'bold'),
    'prose-h3:sui-h1-bold': (element === 'h3') && (variant === 'h1') && (weight === 'bold'),
    'prose-h4:sui-h1-bold': (element === 'h4') && (variant === 'h1') && (weight === 'bold'),
    'prose-h5:sui-h1-bold': (element === 'h5') && (variant === 'h1') && (weight === 'bold'),
    'prose-h6:sui-h1-bold': (element === 'h6') && (variant === 'h1') && (weight === 'bold'),
    // H2 element bold styling
    'prose-h1:sui-h2-bold': (element === 'h1') && (variant === 'h2') && (weight === 'bold'),
    'prose-h2:sui-h2-bold': (element === 'h2') && (variant === 'h2') && (weight === 'bold'),
    'prose-h3:sui-h2-bold': (element === 'h3') && (variant === 'h2') && (weight === 'bold'),
    'prose-h4:sui-h2-bold': (element === 'h4') && (variant === 'h2') && (weight === 'bold'),
    'prose-h5:sui-h2-bold': (element === 'h5') && (variant === 'h2') && (weight === 'bold'),
    'prose-h6:sui-h2-bold': (element === 'h6') && (variant === 'h2') && (weight === 'bold'),
    // H3 element bold styling
    'prose-h1:sui-h3-bold': (element === 'h1') && (variant === 'h3') && (weight === 'bold'),
    'prose-h2:sui-h3-bold': (element === 'h2') && (variant === 'h3') && (weight === 'bold'),
    'prose-h3:sui-h3-bold': (element === 'h3') && (variant === 'h3') && (weight === 'bold'),
    'prose-h4:sui-h3-bold': (element === 'h4') && (variant === 'h3') && (weight === 'bold'),
    'prose-h5:sui-h3-bold': (element === 'h5') && (variant === 'h3') && (weight === 'bold'),
    'prose-h6:sui-h3-bold': (element === 'h6') && (variant === 'h3') && (weight === 'bold'),
    // H4 element bold styling
    'prose-h1:sui-h4-bold': (element === 'h1') && (variant === 'h4') && (weight === 'bold'),
    'prose-h2:sui-h4-bold': (element === 'h2') && (variant === 'h4') && (weight === 'bold'),
    'prose-h3:sui-h4-bold': (element === 'h3') && (variant === 'h4') && (weight === 'bold'),
    'prose-h4:sui-h4-bold': (element === 'h4') && (variant === 'h4') && (weight === 'bold'),
    'prose-h5:sui-h4-bold': (element === 'h5') && (variant === 'h4') && (weight === 'bold'),
    'prose-h6:sui-h4-bold': (element === 'h6') && (variant === 'h4') && (weight === 'bold'),
    // H5 element bold styling
    'prose-h1:sui-h5-bold': (element === 'h1') && (variant === 'h5') && (weight === 'bold'),
    'prose-h2:sui-h5-bold': (element === 'h2') && (variant === 'h5') && (weight === 'bold'),
    'prose-h3:sui-h5-bold': (element === 'h3') && (variant === 'h5') && (weight === 'bold'),
    'prose-h4:sui-h5-bold': (element === 'h4') && (variant === 'h5') && (weight === 'bold'),
    'prose-h5:sui-h5-bold': (element === 'h5') && (variant === 'h5') && (weight === 'bold'),
    'prose-h6:sui-h5-bold': (element === 'h6') && (variant === 'h5') && (weight === 'bold'),
    // H6 element bold styling
    'prose-h1:sui-h6-bold': (element === 'h1') && (variant === 'h6') && (weight === 'bold'),
    'prose-h2:sui-h6-bold': (element === 'h2') && (variant === 'h6') && (weight === 'bold'),
    'prose-h3:sui-h6-bold': (element === 'h3') && (variant === 'h6') && (weight === 'bold'),
    'prose-h4:sui-h6-bold': (element === 'h4') && (variant === 'h6') && (weight === 'bold'),
    'prose-h5:sui-h6-bold': (element === 'h5') && (variant === 'h6') && (weight === 'bold'),
    'prose-h6:sui-h6-bold': (element === 'h6') && (variant === 'h6') && (weight === 'bold'),
    // H1 element display styles
    'prose-h1:sui-h1-display': (element === 'h1') && (variant === 'h1') && (weight === 'display'),
    'prose-h2:sui-h1-display': (element === 'h2') && (variant === 'h1') && (weight === 'display'),
    'prose-h3:sui-h1-display': (element === 'h3') && (variant === 'h1') && (weight === 'display'),
    'prose-h4:sui-h1-display': (element === 'h4') && (variant === 'h1') && (weight === 'display'),
    'prose-h5:sui-h1-display': (element === 'h5') && (variant === 'h1') && (weight === 'display'),
    'prose-h6:sui-h1-display': (element === 'h6') && (variant === 'h1') && (weight === 'display'),
    // H2 element display styles
    'prose-h1:sui-h2-display': (element === 'h1') && (variant === 'h2') && (weight === 'display'),
    'prose-h2:sui-h2-display': (element === 'h2') && (variant === 'h2') && (weight === 'display'),
    'prose-h3:sui-h2-display': (element === 'h3') && (variant === 'h2') && (weight === 'display'),
    'prose-h4:sui-h2-display': (element === 'h4') && (variant === 'h2') && (weight === 'display'),
    'prose-h5:sui-h2-display': (element === 'h5') && (variant === 'h2') && (weight === 'display'),
    'prose-h6:sui-h2-display': (element === 'h6') && (variant === 'h2') && (weight === 'display'),
    // H3 element display styles
    'prose-h1:sui-h3-display': (element === 'h1') && (variant === 'h3') && (weight === 'display'),
    'prose-h2:sui-h3-display': (element === 'h2') && (variant === 'h3') && (weight === 'display'),
    'prose-h3:sui-h3-display': (element === 'h3') && (variant === 'h3') && (weight === 'display'),
    'prose-h4:sui-h3-display': (element === 'h4') && (variant === 'h3') && (weight === 'display'),
    'prose-h5:sui-h3-display': (element === 'h5') && (variant === 'h3') && (weight === 'display'),
    'prose-h6:sui-h3-display': (element === 'h6') && (variant === 'h3') && (weight === 'display'),
    // H4 element display styles
    'prose-h1:sui-h4-display': (element === 'h1') && (variant === 'h4') && (weight === 'display'),
    'prose-h2:sui-h4-display': (element === 'h2') && (variant === 'h4') && (weight === 'display'),
    'prose-h3:sui-h4-display': (element === 'h3') && (variant === 'h4') && (weight === 'display'),
    'prose-h4:sui-h4-display': (element === 'h4') && (variant === 'h4') && (weight === 'display'),
    'prose-h5:sui-h4-display': (element === 'h5') && (variant === 'h4') && (weight === 'display'),
    'prose-h6:sui-h4-display': (element === 'h6') && (variant === 'h4') && (weight === 'display'),
    // H5 element display styles
    'prose-h1:sui-h5-display': (element === 'h1') && (variant === 'h5') && (weight === 'display'),
    'prose-h2:sui-h5-display': (element === 'h2') && (variant === 'h5') && (weight === 'display'),
    'prose-h3:sui-h5-display': (element === 'h3') && (variant === 'h5') && (weight === 'display'),
    'prose-h4:sui-h5-display': (element === 'h4') && (variant === 'h5') && (weight === 'display'),
    'prose-h5:sui-h5-display': (element === 'h5') && (variant === 'h5') && (weight === 'display'),
    'prose-h6:sui-h5-display': (element === 'h6') && (variant === 'h5') && (weight === 'display'),
    // H6 element display styles
    'prose-h1:sui-h6-display': (element === 'h1') && (variant === 'h6') && (weight === 'display'),
    'prose-h2:sui-h6-display': (element === 'h2') && (variant === 'h6') && (weight === 'display'),
    'prose-h3:sui-h6-display': (element === 'h3') && (variant === 'h6') && (weight === 'display'),
    'prose-h4:sui-h6-display': (element === 'h4') && (variant === 'h6') && (weight === 'display'),
    'prose-h5:sui-h6-display': (element === 'h5') && (variant === 'h6') && (weight === 'display'),
    'prose-h6:sui-h6-display': (element === 'h6') && (variant === 'h6') && (weight === 'display'),
    // Body styles
    'prose-p:sui-text-base': (element === 'paragraph') && (variant === 'body-base'),
    'prose-p:sui-text-xs': (element === 'paragraph') && (variant === 'body-xs'),
    'prose-p:sui-text-lg': (element === 'paragraph') && (variant === 'body-lg'),
    'prose-p:sui-font-regular': (element === 'paragraph') && (weight === 'regular'),
    'prose-p:sui-font-bold': (element === 'paragraph') && (weight === 'bold')
  });
};

export default function createProse(props) {
  const parsedProps = {
    h1: { ...baseProps?.h1, ...props?.h1 },
    h2: { ...baseProps?.h2, ...props?.h2 },
    h3: { ...baseProps?.h3, ...props?.h3 },
    h4: { ...baseProps?.h4, ...props?.h4 },
    h5: { ...baseProps?.h5, ...props?.h5 },
    h6: { ...baseProps?.h6, ...props?.h6 },
    paragraph: { ...baseProps?.paragraph, ...props?.paragraph }
  };

  const {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    paragraph
  } = parsedProps;

  const classes = {
    h1: {
      align: getAlignmentClasses({ h1 }),
      color: getColorClasses({ h1 }),
      decoration: getDecorationClasses({ h1 }),
      height: getHeightClasses({ h1 }),
      lineClamp: getLineClampClasses({ h1 }),
      uppercase: getUppercaseClasses({ h1 }),
      truncate: getTruncateClasses({ h1 }),
      variant: getVariantClasses({ h1 })
    },
    h2: {
      align: getAlignmentClasses({ h2 }),
      color: getColorClasses({ h2 }),
      decoration: getDecorationClasses({ h2 }),
      height: getHeightClasses({ h2 }),
      lineClamp: getLineClampClasses({ h2 }),
      uppercase: getUppercaseClasses({ h2 }),
      truncate: getTruncateClasses({ h2 }),
      variant: getVariantClasses({ h2 })
    },
    h3: {
      align: getAlignmentClasses({ h3 }),
      color: getColorClasses({ h3 }),
      decoration: getDecorationClasses({ h3 }),
      height: getHeightClasses({ h3 }),
      lineClamp: getLineClampClasses({ h3 }),
      uppercase: getUppercaseClasses({ h3 }),
      truncate: getTruncateClasses({ h3 }),
      variant: getVariantClasses({ h3 }),
    },
    h4: {
      align: getAlignmentClasses({ h4 }),
      color: getColorClasses({ h4 }),
      decoration: getDecorationClasses({ h4 }),
      height: getHeightClasses({ h4 }),
      lineClamp: getLineClampClasses({ h4 }),
      uppercase: getUppercaseClasses({ h4 }),
      truncate: getTruncateClasses({ h4 }),
      variant: getVariantClasses({ h4 })
    },
    h5: {
      align: getAlignmentClasses({ h5 }),
      color: getColorClasses({ h5 }),
      decoration: getDecorationClasses({ h5 }),
      height: getHeightClasses({ h5 }),
      lineClamp: getLineClampClasses({ h5 }),
      uppercase: getUppercaseClasses({ h5 }),
      truncate: getTruncateClasses({ h5 }),
      variant: getVariantClasses({ h5 })
    },
    h6: {
      align: getAlignmentClasses({ h6 }),
      color: getColorClasses({ h6 }),
      decoration: getDecorationClasses({ h6 }),
      height: getHeightClasses({ h6 }),
      lineClamp: getLineClampClasses({ h6 }),
      uppercase: getUppercaseClasses({ h6 }),
      truncate: getTruncateClasses({ h6 }),
      variant: getVariantClasses({ h6 })
    },
    paragraph: {
      align: getAlignmentClasses({ paragraph }),
      color: getColorClasses({ paragraph }),
      decoration: getDecorationClasses({ paragraph }),
      height: getHeightClasses({ paragraph }),
      lineClamp: getLineClampClasses({ paragraph }),
      truncate: getTruncateClasses({ paragraph }),
      variant: getVariantClasses({ paragraph })
    }
  };
  return Object.entries(classes).map((ele) => Object.entries(ele[1]).map((entry) => entry[1]).filter((string) => string !== '').join(' '));
}
